<template>
 <div class="comment-container">
    <SUserAvatar :myUser="comment.sender" size="small" :isProfileAvatar="false"/>
    <div class="comment-container-box">
      <p class="sender-name">{{`${comment.sender.firstName} ${comment.sender.lastName || ''}`}}</p>
      <span class="sender-username">@{{comment.sender.username}}</span>
      <p class="sender-comment">{{comment.comment}}</p>
    </div>
  </div>
</template>

<script>
import SUserAvatar from "@/material-components/atoms/SUserAvatar";

  export default {
  name: "CurrentMessageComments",
  props: ['comment'],
  components: {
    SUserAvatar,
  },
  }
</script>

<style scoped>
  .comment-container {
    margin: 10px 35px;
    display: flex;
    justify-content: left;
    align-items: center;
  }

  .md-avatar {
    margin: unset;
  }

  .comment-container-box {
    margin-left: 10px;
  }

  .sender-name {
    margin: unset !important;
    color: black;
    font-size: 16px;
  }

  .sender-username {
    color: #888da8;
    font-size: 10px;
  }

  .sender-comment {
    color: rgb(74, 74, 74);
    margin: unset !important;
  }
</style>